export default {"src":"/_next/static/media/PA.dfc16b66.svg","height":63,"width":60};